export default {"src":"/_next/static/media/ic_paging_prev.1bc89129.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};